export const apiUrl = 'http://192.168.100.12:3000/';
